"use client";
import { discoverySchemas, type DiscoveryAction } from "@/lib/webmcp/discovery";
import { useWebMcpTool } from "@/lib/webmcp/react";
import type { AppLocale } from "@/lib/i18n/constants";
function DiscoveryTool({ action, locale }: { action: DiscoveryAction; locale: AppLocale }) {
  useWebMcpTool({ action, schema: discoverySchemas[action], execute: async (input, { signal }) => {
    const response = await fetch("/api/webmcp", { method: "POST", headers: { "Content-Type": "application/json" }, credentials: "omit", signal, body: JSON.stringify({ action, locale, input }) });
    if (!response.ok) return { status: "unavailable" };
    const payload = await response.json();
    return { status: payload.status === "success" ? "success" : "unavailable", data: payload.data };
  } });
  return null;
}
export default function WebMcpDiscovery({ locale }: { locale: AppLocale }) {
  return Object.keys(discoverySchemas).map((action) => <DiscoveryTool key={action} action={action as DiscoveryAction} locale={locale} />);
}
